/**
 * Created by glopez on 19/04/17.
 */

import {ActionTypes} from '../actions/modal';

/**
 * Returns the modal's shown state.
 *
 * @param {boolean} state - Current state.
 * @param {Object} action - Action object.
 * @returns {boolean} State.
 */
function getIsShow (state = false, action) {

    switch (action.type) {

        case ActionTypes.SET_MODAL_SHOW:
        case ActionTypes.SET_MODAL_HIDE:

            return (state = action.data);

        default:
            return state;
    }
}

/**
 * Returns the modal's type state.
 *
 * @param {string} state - Current state.
 * @param {Object} action - Action object.
 * @returns {string} State.
 */
function getType (state = '', action) {

    switch (action.type) {

        case ActionTypes.SET_MODAL_TYPE:
            return (state = action.data);

        default:
            return state;
    }
}

/**
 * Returns the modal's loading state.
 *
 * @param {boolean} state - Current state.
 * @param {Object} action - Action object.
 * @returns {boolean} State.
 */
function getStatus (state = false, action) {

    switch (action.type) {

        case ActionTypes.SET_MODAL_STATUS:
            return (state = action.data);

        default:
            return state;
    }
}

/**
 * Provides the beforeClose method state.
 *
 * @param {Function|null} [state] - The current state.
 * @param {Object} action - Action object.
 * @returns {Function|null} The current/new state.
 */
function beforeClose (state = null, action) {

    switch (action.type) {

        case ActionTypes.SET_MODAL_HIDE:
        case ActionTypes.SET_BEFORE_CLOSE:
            return (state = action.method);

        default:
            return state;
    }
}

/**
 * Provides the afterClose method state.
 *
 * @param {Function|null} [state] - The current state.
 * @param {Object} action - Action object.
 * @returns {Function|null} The current/new state.
 */
function afterClose (state = null, action) {

    switch (action.type) {

        case ActionTypes.SET_MODAL_HIDE:
        case ActionTypes.SET_AFTER_CLOSE:
            return (state = action.method);

        default:
            return state;
    }
}

/**
 * Returns the modal's state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
function modal (state = {}, action) {
    return {
        show: getIsShow(state.show, action),
        type: getType(state.type, action),
        status: getStatus(state.status, action),
        beforeClose: beforeClose(state.beforeClose, action),
        afterClose: afterClose(state.afterClose, action)
    };
}

export default modal;


// WEBPACK FOOTER //
// ./src/js/store/reducers/modal.js